import React, { useState, useEffect } from "react";
import useMakeScrollable from "custom_hooks/make-scrollable";
import closeIcon from "../../assets/images/close_icon.png";
import { useQuery, useMutation } from "@apollo/client";
import { GET_GENERAL_TERMS, GET_PRIVACY } from "queries/queries";
import { ACCEPT_GENERAL_TERMS, ACCEPT_PRIVACY } from "queries/mutations";

const AcceptDataModal = ({ terms, privacy }) => {
  useMakeScrollable();

  const [showTerms, setShowTerms] = useState(terms); 
  const [showPrivacy, setShowPrivacy] = useState(privacy && !terms); 

  useEffect(() => {
    setShowTerms(!!terms);
    setShowPrivacy(!!privacy && !terms);
  }, [terms, privacy]);

  const generalTerms = useQuery(GET_GENERAL_TERMS, {
    fetchPolicy: "no-cache",
  });

  const privacyTerms = useQuery(GET_PRIVACY, {
    fetchPolicy: "no-cache",
  });

  const [acceptGeneralTerms] = useMutation(ACCEPT_GENERAL_TERMS, {
    onError: (data) => {
      console.log("[Error] General Terms Mutation:", data);
    },
  });
  
  const [acceptPrivacy] = useMutation(ACCEPT_PRIVACY, {
    onError: (data) => {
      console.log("[Error] Privacy Mutation:", data);
    },
  });  

  if (!terms && !privacy) return null;
  if (!showTerms && !showPrivacy) return null;  

  const handleButtonClick = (accepted) => {
    const mutation = showTerms ? acceptGeneralTerms : acceptPrivacy;
  
    mutation({
      variables: { accepted },
    })
      .then(() => {
        if (showTerms && privacy) {
          setShowTerms(false);
          setShowPrivacy(true);
        } else {
          setShowTerms(false);
          setShowPrivacy(false);
        }
      })
      .catch((err) => {
        console.error("Error accepting terms:", err);
      });
  };
  

  const title = showTerms
    ? generalTerms.data?.getGeneralTerms?.name
    : privacyTerms.data?.getPrivacy?.name;

  const content = showTerms
    ? generalTerms.data?.getGeneralTerms?.content
    : privacyTerms.data?.getPrivacy?.content;


  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div 
          className="modal-closeButton"
          onClick={(e) => {
            handleButtonClick(false);
          }}
        >
          <img src={closeIcon} alt="Close" />
        </div>
        <div 
          className="modal-title">{title}</div>
        <div 
          className="modal-text"
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
        <div className="modal-buttons">
          <div 
            className="modal-buttons-primary"
            onClick={(e) => {
              handleButtonClick(true);
            }}
          >
            Akzeptieren
          </div>
          <div 
            className="modal-buttons-secondary"
            onClick={(e) => {
              handleButtonClick(false);
            }}
          >Ablehnen</div>
        </div>
      </div>
    </div>
  );
};

export default AcceptDataModal;
